import { render, staticRenderFns } from "./ItemMajor.vue?vue&type=template&id=9f627164&scoped=true"
import script from "./ItemMajor.vue?vue&type=script&lang=js"
export * from "./ItemMajor.vue?vue&type=script&lang=js"
import style0 from "./ItemMajor.vue?vue&type=style&index=0&id=9f627164&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f627164",
  null
  
)

export default component.exports